import { render, staticRenderFns } from "./navbarMobile.vue?vue&type=template&id=1820a642&scoped=true"
import script from "./navbarMobile.vue?vue&type=script&lang=js"
export * from "./navbarMobile.vue?vue&type=script&lang=js"
import style0 from "./navbarMobile.vue?vue&type=style&index=0&id=1820a642&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1820a642",
  null
  
)

export default component.exports